(function(angular, module) {var pickerBreadcrumbController, pickerBreadcrumbDirective;

pickerBreadcrumbController = function($scope) {
  'ngInject';
  var stop;
  stop = this.tagPicker.tree.onNodeChange((function(_this) {
    return function(node) {
      _this.atRoot = node.isRoot;
      _this.nodes = node.getBreadcrumb().slice(-2);
    };
  })(this));
  $scope.$on('$destroy', stop);
};

pickerBreadcrumbDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/tags/pickerBreadcrumb',
    controller: pickerBreadcrumbController,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      tagPicker: '='
    }
  };
};

module.directive('dybTagPickerBreadcrumb', pickerBreadcrumbDirective);
})(angular, angular.module("dybTags"));